import ProfileRelationshipsListReducer from './ProfileRelationshipsListReducer';

export default from './ProfileRelationshipsListContainer';
export const ProfileRelationshipsListReducers = {
  ProfileRelatioonshipsMappingRelationshipsListReducer: ProfileRelationshipsListReducer,
};
